
export class DeviceModel {
  id: string|null;
  userId: string|null;
  name: string;
}
